import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  isProcessCanceledByUser,
  Log,
  RydeProcessTitle,
  RydeUiUnit,
  supportsBulkSummaryToast,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkImport = ({ entity }: { entity: RydeUiUnit }) => {
  const bulkImportProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkImport,
    entity,
  );

  const bulkImportProcess = useRecoilValue(
    activeProcessSF(bulkImportProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      if (isProcessCanceledByUser(process)) {
        return;
      }

      if (
        !supportsBulkSummaryToast(entity) &&
        process?.metadata?.metrics?.total
      ) {
        Log.infoAndToast(
          t("general.ENTITY_SUCCESSFULLY_UPDATED", {
            entity: t("station.plural"),
          }),
        );
      }
    },
    [entity, t],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkImport,
      process: bulkImportProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
      toastSummaryOnComplete: supportsBulkSummaryToast(entity),
    });
  }, [bulkImportProcess, entity, onComplete, stopProcessPolling, t]);
};
